import { SVGProps, Ref, forwardRef } from 'react';

export const ForwardFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M.722 6.233c.722-.555 1.738-.067 3.768.91l2.92 1.403C10.47 10.017 12 10.753 12 12s-1.53 1.983-4.59 3.454l-2.92 1.404c-2.03.976-3.046 1.464-3.768.909C0 17.21 0 15.942 0 13.403v-2.806c0-2.539 0-3.808.722-4.364"
                fill="currentColor"
            />
            <path
                d="M12.722 6.233c.722-.555 1.738-.067 3.768.91l2.92 1.403C22.47 10.017 24 10.753 24 12s-1.53 1.983-4.59 3.454l-2.92 1.404c-2.03.976-3.046 1.464-3.768.909C12 17.21 12 15.942 12 13.403v-2.806c0-2.539 0-3.808.722-4.364"
                fill="currentColor"
            />
        </g>
    </svg>
));
ForwardFilledSize24Glyph.displayName = 'ForwardFilledSize24Glyph';
